import { useState, useEffect } from 'react'
import firebase from '../firebase/firebase'
import { rolesObj, sectorsObj, storesObj } from 'src/scripts/datats'
import { getAuth, getRedirectResult, getAdditionalUserInfo, AdditionalUserInfo, OAuthProvider, linkWithCredential } from 'firebase/auth'
import { FirebaseError } from 'firebase/app'
import Swal from 'sweetalert2'
import { signInAgain } from 'src/utils/swal.utils'

interface Props {
  userDataPresent: boolean
  user: any | null
}

async function handleRedirectResult() {
  console.log('aqui')
  const auth = getAuth()

  try {
    console.log('aqui1')

    const result = await getRedirectResult(auth)

    if (!result) return // No hay resultado, usuario no redirigido

    const userData: AdditionalUserInfo | null = getAdditionalUserInfo(result)

    // Expresión regular para buscar específicamente 'ROLE-METAPHYSIO-ROLE_' seguido de un número
    const pattern = /ROLE-METAPHYSIO-ROLE_(\d+)/

    // Filtrar y extraer el número
    const roleNumber = (userData?.profile?.memberof as any).reduce((acc: any, item: any) => {
      const match = item.match(pattern)
      if (match) {
        acc.push(match[1]) // extrae el número encontrado después de 'ROLE-METAPHYSIO-ROLE_'
      }
      return acc
    }, [])

    if (!roleNumber) {
      const user = auth.currentUser
      user
        ?.delete()
        .then(async () => {
          Swal.fire({
            icon: 'error',
            width: 440,
            confirmButtonText: 'OK',
            confirmButtonColor: '#1870c7',
            html: `<h6>Acceso no permitido</h4>`,
            showConfirmButton: true
          })
          console.log('user deleted due to not permission')
        })
        .catch(async (error) => {
          await firebase.db
            .collection('errorslogs')
            .add({ error: JSON.stringify(error, Object.getOwnPropertyNames(error)), createdAt: Date.now() })
          console.log(error)
        })

      return
    }

    if (userData?.isNewUser) {
      console.log('aqui2')

      const userInfo = firebase.db.collection('users').doc(result.user.uid)
      if (userData.profile) {
        await firebase.db.collection('pingidlogs').add({
          ...userData.profile,
          success: 'new',
          createdAt: Date.now()
        })
      }

      await userInfo.set({
        birthday: '01/01/1900',
        company: { id: 'xnR745oszYN4mRTAJiLY', name: 'Obramat (BRICOLAJE BRICOMAN, S.L.U.)' },
        companyId: 'xnR745oszYN4mRTAJiLY',
        createdAt: Date.now(),
        comunPatology: { id: false, name: 'No' },
        comunPatologyBookings: 0,
        deleted: false,
        createdBy: 'oidc',
        method: 'oidc',
        email: result.user.email,
        employeeId: userData?.profile?.uid,
        fullName: userData?.profile?.name,
        id: result.user.uid,
        lastname: userData?.profile?.family_name,
        lastname2: '',
        name: userData?.profile?.given_name,
        role: { ...rolesObj[String(userData?.profile?.title)], id: `role${roleNumber}` },
        sector: userData?.profile?.departmentnumber ? sectorsObj[String(userData?.profile.departmentnumber)] : null,
        store: storesObj[String(userData?.profile?.businesscategory)],
        storeId: storesObj[String(userData?.profile?.businesscategory)].id,
        workingSince: String(userData?.profile?.privContractStartDate).split('/').reverse().join('/'),
        gender: { id: '-', name: '-' }
      })

      const getOldBookings = firebase.functions.httpsCallable('getOldBookings')

      await getOldBookings({ email: result.user.email, newUid: result.user.uid })

      if (userData?.profile?.departmentnumber === 'ACABADO') {
        const updateEmployeeSector = firebase.functions.httpsCallable('getSectorSexBirthday')

        try {
          return await updateEmployeeSector(result.user.email)
        } catch (error) {
          console.log(error)
          console.log('error2')

          throw new Error('Hubo un error mientras actualizabamos el sector')
        }
      }
    } else {
      console.log('aqui3')

      console.log('usuario ya existia')
      const userInfo = firebase.db.collection('users').doc(result.user.uid)

      if (userData?.profile) {
        await firebase.db.collection('pingidlogs').add({
          ...userData.profile,
          success: 'old',
          createdAt: Date.now()
        })
      }

      await userInfo.update({
        deleted: false,
        email: result.user.email,
        employeeId: userData?.profile?.uid,
        fullName: userData?.profile?.name,
        lastname: userData?.profile?.family_name,
        lastname2: '',
        name: userData?.profile?.given_name,
        role: { ...rolesObj[String(userData?.profile?.title)], id: `role${roleNumber}` },
        sector: userData?.profile?.departmentnumber ? sectorsObj[String(userData.profile.departmentnumber)] : null,
        store: storesObj[String(userData?.profile?.businesscategory)],
        storeId: storesObj[String(userData?.profile?.businesscategory)].id
      })

      if (userData?.profile?.departmentnumber === 'ACABADO') {
        const updateEmployeeSector = firebase.functions.httpsCallable('getSectorSexBirthday')

        try {
          return await updateEmployeeSector(result.user.email)
        } catch (error) {
          console.log('error4 employee')

          await firebase.db
            .collection('errorslogs')
            .add({ error: JSON.stringify(error, Object.getOwnPropertyNames(error)), createdAt: Date.now() })
          console.log(error)

          throw new Error('Hubo un error mientras actualizabamos el sector')
        }
      }
    }
  } catch (error: any) {
    console.log('aqui4')
    if (error?.toString().includes('account-exists-with-different-credential')) {
      const credential = OAuthProvider.credentialFromError(error as FirebaseError)

      if (credential) {
        Swal.fire({
          title: 'Vincular cuenta',
          confirmButtonText: 'Vincular',
          confirmButtonColor: '#1870c7',
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
          html: `
    <span class="swal2-span" styles={{fontSize:'10px'}}>Introduce tu email y contraseña de Metaphysio</span>
    <input id="swal-input1" class="swal2-input" placeholder="Email" type="email">
    <input id="swal-input2" class="swal2-input" placeholder="Contraseña" type="password">
  `,
          focusConfirm: false,
          preConfirm: () => {
            firebase.auth
              .signInWithEmailAndPassword(
                (document.getElementById('swal-input1') as HTMLInputElement)!.value,
                (document.getElementById('swal-input2') as HTMLInputElement)!.value
              )
              .then((result) => {
                if (credential && result.user) {
                  return linkWithCredential(result.user, credential)
                    .then(() => {
                      // Sign in with the newly linked credential
                      return firebase.auth.signInWithCredential(credential)
                    })
                    .then((signInResult: any) => {
                      // Save the merged data to the new user

                      Swal.fire(signInAgain('#1870c7'))
                      firebase.auth.signOut()
                      // window.location.reload()
                    })
                }
              })
              .catch(async (error) => {
                await firebase.db
                  .collection('errorslogs')
                  .add({ error: JSON.stringify(error, Object.getOwnPropertyNames(error)), createdAt: Date.now() })
                if ((error as any).code === 'auth/wrong-password') {
                  Swal.fire({
                    icon: 'error',
                    width: 440,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#1870c7',
                    html: `<h6>La contraseña es incorrecta, inténtelo de nuevo</h4>`,
                    showConfirmButton: true
                  })
                } else if ((error as any).code === 'auth/too-many-requests') {
                  Swal.fire({
                    icon: 'error',
                    width: 440,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#1870c7',
                    html: `<h6>El usuario se ha bloqueado por seguridad, inténtelo de nuevo mas tarde</h4>`,
                    showConfirmButton: true
                  })
                } else {
                  Swal.fire({
                    icon: 'error',
                    width: 440,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#1870c7',
                    html: `<h6>Ha habido un error, inténtelo de nuevo</h4>`,
                    showConfirmButton: true
                  })
                }
                // If there are errors we want to undo the data merge/deletion
                console.log('Sign In Error', error)
              })
          }
        })
      }
    } else {
      console.log(error)
      await firebase.db
        .collection('errorslogs')
        .add({ error: JSON.stringify(error, Object.getOwnPropertyNames(error)), createdAt: Date.now() })
    }

    console.error('Error handling redirect result:', error)
  }
}

function useAuthentication(): Props {
  const [authenticateUser, setAuthenticateUser] = useState<Props>({
    userDataPresent: false,
    user: null
  })

  useEffect(() => {
    // Primero manejamos el resultado del redirect
    handleRedirectResult()

    // Luego nos suscribimos a los cambios de auth state
    const unsuscribe = firebase.auth.onAuthStateChanged((user: any) => {
      if (user) {
        setAuthenticateUser({ userDataPresent: true, user: user })
      } else {
        setAuthenticateUser({ userDataPresent: true, user: null })
      }
    })

    return () => unsuscribe()
  }, [])

  return authenticateUser
}

export default useAuthentication
